import React, { useContext } from 'react'
import { Phone, Send, LogOut, WifiOff } from 'lucide-react';
import { CantiqueContextAPI } from '../Context/CantiqueContext';
import useOnlineStatus from '../hooks/useOnlineStatus';
import { reopenGpsConsent } from '../utils/visitorTracking';

const FooterSidebard = () => {
  const { allCantiques, filteredCantiques, catalogStatus } = useContext(CantiqueContextAPI);
  const online = useOnlineStatus();
  const total = allCantiques.length;
  const shown = filteredCantiques.length;
  const offlineNote = !online || catalogStatus === 'cached';
  return (
    <div className="FooterSidebard">
         <div className="FooterSidebard__container">
             <div className="FooterSidebard__quantiy">
                 <div className="FooterSidebard__quantity__cantiques" aria-live="polite">
                    {shown}/{total} cantiques
                 </div>
                 {offlineNote && (
                   <div
                     className="FooterSidebard__offline"
                     role="status"
                     title="Les paroles déjà chargées restent lisibles. L’audio nécessite une connexion."
                   >
                     <WifiOff size={12} />
                     <span>
                       {online ? 'Serveur injoignable' : 'Hors connexion'}
                       {total > 0 ? ' · paroles enregistrées' : ''}
                     </span>
                   </div>
                 )}
             </div>
             <div className="FooterSidebard__infos">
                 <div className="FooterSidebard__infos__item">
                    <a href="https://chat.whatsapp.com/Etm9IakxDxi5sLSJ3DvqKy?mode=gi_t" target='_blank'><Phone size={16}
                    className='FooterSidebard__icon' /></a>
                 </div>
                 <div className="FooterSidebard__infos__item">
                    <a href="https://chat.whatsapp.com/Etm9IakxDxi5sLSJ3DvqKy?mode=gi_t" target='_blank'><Send size={16}
                    className='FooterSidebard__icon' /></a>
                 </div>
             </div>
         </div>
         <p className="FooterSidebard__privacy">
           <strong>Confidentialité :</strong>{' '}
           <button type="button" className="FooterSidebard__privacy__link" onClick={reopenGpsConsent}>
             Modifier mon choix de localisation
           </button>
         </p>
    </div>
  )
}

export default FooterSidebard